<template>
    <v-dialog 
        :value="show"
        fullscreen 
        hide-overlay 
        transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn 
                    icon 
                    dark 
                    :disabled="saving" 
                    @click="close">
                    <v-icon large>close</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    <span>Edit Rates</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-layout class="dialog-content">
                <v-flex xs12 md6 offset-md3 mt-4>
                    <v-layout wrap>
                        <v-data-table
                            :headers="headers"
                            hide-actions
                            :items="items">
                            <template v-slot:items="{ item, index }">
                                <td>{{ moment(item.EffectiveDate).format('YYYY-MM-DD') }}</td>
                                <td>{{ item.DefaultPayRatePerHour.toLocaleString("en-AU", {style:"currency", currency:"AUD"}) }}</td>
                                <template v-if="item.DefaultAllowancePayRatePerHour == null || ''">
                                    <td>n/a</td>
                                </template>
                                <template v-else>
                                    <td>{{ item.DefaultAllowancePayRatePerHour.toLocaleString("en-AU", {style:"currency", currency:"AUD"}) }}</td>
                                </template>
                                <td>
                                    <v-btn icon @click="handleEditRate(item, index)" small>
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                    <v-btn icon @click="handleDeleteRate(item, index)" small>
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </td>
                            </template>
                            <template v-slot:footer>
                                <td :colspan="4">
                                    <v-btn 
                                        color="primary" 
                                        @click="handleAddRate()">
                                        <span>New Rate</span>
                                    </v-btn>
                                </td>
                            </template>
                        </v-data-table>
                    </v-layout>
                    <v-layout wrap class="dialog-action-buttons">
                        <v-flex xs12 sm6>
                            <v-btn 
                                block 
                                color="success" 
                                :loading="saving" 
                                @click="save">
                                <span>Save</span>
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-btn 
                                block 
                                color="error" 
                                :disabled="saving" 
                                @click="close">
                                <span>Cancel</span>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-alert 
                                :value="error" 
                                outline 
                                type="error">
                                <span>{{ error }}</span>
                            </v-alert>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card>
        <RoleTypeRatesAddEdit :show="displayRateEdit" :rate="editRate" @confirm="handleRateEditConfirm" @cancel="handleRateEditCancel">
        </RoleTypeRatesAddEdit>
    </v-dialog>
</template>

<script>
import ConfigurationAPI from "@/api/configurationApi";
import BaseAPI from "@/api/baseApi";
import moment from "moment";
import * as Constants from "@/helpers/constants";
import validationRules from "@/helpers/validationrules";
import RoleTypeRatesAddEdit from "@/components/configuration/roles/RoleTypeRatesAddEdit.vue";

export default {
    props: {
        originalItem: {
            required: false,
            type: Object,
            default: null
        },
        show: {
            required: true,
            type: Boolean,
            default: false
        },
    },
    components: {
        RoleTypeRatesAddEdit
    },
    data() {
        return {
            moment,
            saving: false,
            error: null,
            editRate: null,
            editIndex: -1,
            displayRateEdit: false,
            items: [],
            headers: [
                {
                    text: "Effective Date",
                    value: "EffectiveDate",
                    sortable: false
                },
                {
                    text: "Default PayRate/Hour",
                    value: "DefaultPayRatePerHour",
                    sortable: false
                },
                {
                    text: "Default Allowance/Hour",
                    value: "DefaultAllowancePayRatePerHour",
                    sortable: false
                },
                {
                    text: "",
                    value: "Edit",
                    sortable: false
                }
            ]
        }
    },
    computed: {
        
    },
    mounted() {
        
    },
    methods: {
        close(refresh = false) {
            this.$emit("close", refresh);
        },
        handleAddRate(){
            var newIndex = this.items.length;
            // add new rate
            this.items.push({
                RoleTypeRateID: -1,
                RoleTypeID: this.originalItem.RoleTypeID,
                EffectiveDate: new Date(),
                DefaultPayRatePerHour: 0,
                DefaultAllowancePayRatePerHour: 0
            });
            // open edit dialog
            this.handleEditRate(this.items[newIndex], newIndex);
        },
        handleEditRate(item, index){
            this.displayRateEdit = true;
            this.editIndex = index;
            this.editRate = item;
        },
        handleDeleteRate(item, index) {
            this.items.splice(index, 1);
        },
        handleRateEditCancel(rate){
            this.displayRateEdit = false;
            this.editIndex = -1;
            this.editRate = null;
        },
        handleRateEditConfirm(rate){
            // convert the decimal strings to numbers
            rate.DefaultPayRatePerHour = parseFloat(rate.DefaultPayRatePerHour);
            if(rate.DefaultAllowancePayRatePerHour == null || rate.DefaultAllowancePayRatePerHour == ''){
                rate.DefaultAllowancePayRatePerHour = null;
            }
            else {
                rate.DefaultAllowancePayRatePerHour = parseFloat(rate.DefaultAllowancePayRatePerHour);
            }
            
            
            this.$set(this.items, this.editIndex, rate);
            // this.items[this.editIndex] = rate;
            this.handleRateEditCancel();
        },
        async save() {
            try {
                this.saving = true;
                this.error = null;
                var response = await ConfigurationAPI.saveRoleRates(this.items);
                if(response != undefined && !response.Success){
                    console.log('error', response.ErrorMessages);
                    this.error = response.ErrorMessages.join(', ');
                }
                this.close(true);
            }
            catch (err) {
                this.error = await BaseAPI.parseHttpRequestError(err);
                throw err;
            }
            finally {
                this.saving = false;
            }
        },
    },
    watch: {
        show: {
            handler(newVal, oldVal) {
                if (newVal != oldVal && newVal) {
                    this.items = this.items.concat(this.originalItem.Rates)
                }
                else {
                    this.items = [];
                }
            },
            deep: true
        },
        editedItem: {
            // always watch out for this issue: https://github.com/vuejs/vue/issues/2164
            handler(newVal) {
                if (newVal.WorkTypeID == Constants.WORK_TYPES.PICKING.WorkTypeID && newVal.CompanyID != Constants.COMPANIES.CHINA.CompanyID) {
                    this.editedItem.DefaultPayRatePerHour = null;
                }
            },
            deep: true
        }
    },
}
</script>